import { motion } from "framer-motion"
import { xiaozhiPoints, xiaozhiChat, xiaozhiContextTag } from "@/data/xiaozhi"
import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils/cn"

export function Xiaozhi() {
  return (
    <section id="xiaozhi" className="py-24 bg-block-mint">
      <div className="max-w-5xl mx-auto px-4 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* 卖点 */}
        <div>
          <p className="text-caption text-primary mb-3">小智 · AI 学伴</p>
          <h2 className="text-heading text-ink mb-4">
            小智，随时在的 AI 学伴
          </h2>
          <p className="text-body text-ink-soft mb-10 max-w-md">
            它不是搜题机器，而是陪你走完闭环的学伴——知道你在看什么，
            先帮你找卡点，再把思路聊明白。
          </p>

          <ul className="space-y-6">
            {xiaozhiPoints.map((point) => (
              <li key={point.title} className="flex gap-4">
                <div className="w-11 h-11 rounded-md bg-surface-card flex items-center justify-center shrink-0">
                  <point.icon className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="text-heading-sm text-ink mb-1">
                    {point.title}
                  </h3>
                  <p className="text-body text-ink-soft">{point.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* 对话示例 */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3 }}
          className="bg-surface-card rounded-lg border border-hairline p-6 max-w-md w-full mx-auto lg:mx-0 lg:justify-self-end"
        >
          <Badge variant="default" className="mb-6">
            {xiaozhiContextTag}
          </Badge>

          <div className="space-y-4">
            {xiaozhiChat.map((line, index) => (
              <div
                key={index}
                className={cn(
                  "flex",
                  line.role === "student" ? "justify-end" : "justify-start"
                )}
              >
                <div
                  className={cn(
                    "max-w-[85%] rounded-md px-4 py-3 text-body",
                    line.role === "student"
                      ? "bg-primary text-primary-foreground"
                      : "bg-surface-soft text-ink"
                  )}
                >
                  {line.role === "xiaozhi" && (
                    <p className="text-caption text-primary mb-1">小智</p>
                  )}
                  {line.text}
                </div>
              </div>
            ))}
          </div>

          {/* 后续动作（对话示例的一部分） */}
          <div className="mt-6 flex justify-start">
            <span className="inline-flex items-center h-9 px-4 rounded-md border border-primary text-label text-primary">
              去练同类题
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
